module.exports = __webpack_public_path__ + "static/media/pplogo-64.556cd2e5.png";